import toast from "react-hot-toast";
import { privateRequest } from "../axios";

const ENDPOINT = {
    QUESTIONS: '/questions',
    QUESTIONS_SET: '/question-set',
    QUESTIONS_TAGS: '/tags',
};

export const fetchQuestionsSetAPI = async (
    pageNo: number = 0,
    perPage: number = 10,
    search: string = "",
    difficultyLevel: string = "",
    tagIds: number[] = []
) => {
    try {
        const params: any = { pageNo, perPage, search };
        if (difficultyLevel) params.difficultyLevel = difficultyLevel;
        if (tagIds && tagIds.length > 0) params.tagIds = tagIds.join(',');

        const response = await privateRequest.get(
            ENDPOINT.QUESTIONS_SET,
            {
                params,
                headers: {
                    "Content-Type": "application/json"
                }
            }
        );

        

        return response.data;
    } catch (error) {
        console.error('Error fetching questions:', error);
        throw error;
    }
};

export const fetchQuestionsAPI = async (
    pageNo: number = 0,
    perPage: number = 10,
    search: string = "",
    difficultyLevel: string = "",
    tagIds: number[] = []
) => {
    try {
        const params: any = { pageNo, perPage, search };
        if (difficultyLevel) params.difficultyLevel = difficultyLevel;
        if (tagIds && tagIds.length > 0) params.tagIds = tagIds.join(',');

        const response = await privateRequest.get(
            ENDPOINT.QUESTIONS,
            {
                params,
                headers: {
                    "Content-Type": "application/json"
                }
            }
        );

        return response.data;
    } catch (error) {
        console.error('Error fetching questions:', error);
        throw error;
    }
};

export const fetchQuestionsByTagsAPI = async (
    pageNo: number = 1,
    perPage: number = 10,
    search: string = ""
) => {
    try {
        const response = await privateRequest.get(
            `${ENDPOINT.QUESTIONS_TAGS}?pageNo=${pageNo}&perPage=${perPage}&search=${search}`,
            {
                headers: {
                    "Content-Type": "application/json"
                }
            }
        );

        return response.data;
    } catch (error) {
        console.error('Error fetching questions:', error);
        throw error;
    }
};

export const fetchAllTagsAPI = async (pageNo: number = 0, perPage: number = 10, tagType: string = "", search: string = "") => {
    try {
        const response = await privateRequest.get(ENDPOINT.QUESTIONS_TAGS, {
            params: { pageNo, perPage, tagType, search },
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching tags:', error);
        throw error;
    }
};

export const fetchQuestionByIdAPI = async (id: string) => {
    try {
        const response = await privateRequest.get(
            `${ENDPOINT.QUESTIONS_SET}/${id}`,
            {
                headers: {
                    "Content-Type": "application/json"
                }
            }
        );
        console.log("response", response.data);

        return response.data;
    } catch (error) {
        console.error('Error fetching question by ID:', error);
        throw error;
    }
};

export const createQuestionAPI = async (data: any) => {
    try {
        const response = await privateRequest.post(
            ENDPOINT.QUESTIONS_SET,
            data
        );

        return response.data;
    } catch (error) {
        console.error('Error creating question:', error);
        throw error;
    }
};

export const updateQuestionAPI = async (data: any, id: number) => {
    try {
        const response = await privateRequest.put(
            `${ENDPOINT.QUESTIONS_SET}/${id}`,
            data,
            {
                headers: {
                    "Content-Type": "application/json"
                }
            }
        );

        return response.data;
    } catch (error: any) {
        console.error("Error updating question:", error?.response || error);
        throw error;
    }
};

export const deleteQuestionAPI = async (id: string) => {
    try {
        const response = await privateRequest.delete(
            `${ENDPOINT.QUESTIONS_SET}/${id}`
        );

        toast.success(response?.data?.message || "Question deleted successfully");
        return response.data;
    } catch (error) {
        toast.error("Failed to delete question");
        console.error('Error deleting question:', error);
        throw error;
    }
};
export const submitQuestionAnswersAPI = async (data: any) => {
    try {
        const response = await privateRequest.post(`${ENDPOINT.QUESTIONS}/answer/submission`, data, {
            headers: {
                "Content-Type": "application/json"
            }
        });
        return response.data;
    } catch (error) {
        console.error("API Error in submitQuestionAnswersAPI:", error);
        throw error;
    }
};

